// API service for dental notes management
const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001/api';

class DentalNoteService {
  static async createDentalNote(data, token) {
    const response = await fetch(`${API_BASE_URL}/dental-notes`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    });
    if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
    return response.json();
  }

  static async getDentalNoteById(id, token) {
    const response = await fetch(`${API_BASE_URL}/dental-notes/${id}`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });
    if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
    return response.json();
  }

  static async getDentalNotesByPatient(patientId, options = {}, token) {
    const queryParams = new URLSearchParams();
    
    if (options.limit) queryParams.append('limit', options.limit.toString());
    if (options.lastKey) queryParams.append('lastKey', JSON.stringify(options.lastKey));
    if (options.status) queryParams.append('status', options.status);
    if (options.includeArchived) queryParams.append('includeArchived', options.includeArchived.toString());

    const queryString = queryParams.toString();
    const url = `${API_BASE_URL}/dental-notes/patient/${patientId}${queryString ? `?${queryString}` : ''}`;

    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });
    if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
    return response.json();
  }

  static async getAllDentalNotes(options = {}, token) {
    const queryParams = new URLSearchParams();
    
    if (options.limit) queryParams.append('limit', options.limit.toString());
    if (options.lastKey) queryParams.append('lastKey', JSON.stringify(options.lastKey));

    const queryString = queryParams.toString();
    const url = `${API_BASE_URL}/dental-notes${queryString ? `?${queryString}` : ''}`;

    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });
    if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
    return response.json();
  }

  static async updateDentalNote(id, data, token) {
    const response = await fetch(`${API_BASE_URL}/dental-notes/${id}`, {
      method: 'PUT',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    });
    if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
    return response.json();
  }

  static async deleteDentalNote(id, hardDelete = false, token) {
    const url = `${API_BASE_URL}/dental-notes/${id}${hardDelete ? '?hard=true' : ''}`;
    
    const response = await fetch(url, {
      method: 'DELETE',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });
    if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
    return response.json();
  }

  static async archiveDentalNote(id, token) {
    const response = await fetch(`${API_BASE_URL}/dental-notes/${id}/archive`, {
      method: 'PATCH',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });
    if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
    return response.json();
  }

  static async restoreDentalNote(id, token) {
    const response = await fetch(`${API_BASE_URL}/dental-notes/${id}/restore`, {
      method: 'PATCH',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });
    if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
    return response.json();
  }

  static async searchDentalNotes(query, options = {}, token) {
    const queryParams = new URLSearchParams();
    queryParams.append('query', query);
    
    if (options.limit) queryParams.append('limit', options.limit.toString());

    const response = await fetch(`${API_BASE_URL}/dental-notes/search?${queryParams.toString()}`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });
    if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
    return response.json();
  }

  static async getDentalNoteStats(token) {
    const response = await fetch(`${API_BASE_URL}/dental-notes/stats`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });
    if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
    return response.json();
  }
}

export default DentalNoteService;
